import { styled } from '@mui/material';

export const SpanNoWrap = styled('span')({
  whiteSpace: 'nowrap',
});
